import { ConvertedDayPriceMatrix } from './converted-day-price-matrix.model';
import { DayPriceMatrixModel } from './day-price-matrix.model';
import { Group } from '../groups/groups.model';
import { isDate } from 'util'

export function convertDayPriceMatrix(matrices: Array<DayPriceMatrixModel>, offers: Array<Group>): Array<ConvertedDayPriceMatrix > {
	const data = [];

	if (matrices && matrices.length) {
		matrices.forEach(matrix => {
			const tmp = [];

			(Object.keys(matrix) || []).forEach(date => {
				const convertedDate = new Date(date);

				// invalid date return NaN for getTime, and NaN !== NaN
				if (convertedDate.getTime() !== convertedDate.getTime()) {
					return;
				}

				let dataPoint = {date: convertedDate, price: matrix[date]};
				dataPoint = addOffer(dataPoint, offers);
				tmp.push(dataPoint);
			});

			tmp.sort((a, b) => a.date > b.date ? 1 : -1);
			data.push(tmp);
		});

	}

	return data;
}

function addOffer(dataPoint: {date: Date, price: number, offer?: Group}, offers: Array<Group>): {date: Date, price: number, offer?: Group} {
	const dataPointDate = `${dataPoint.date.getFullYear()}-${dataPoint.date.getMonth()}-${dataPoint.date.getDate()}`;

	const filteredOffer = offers.find((offer: Group) => {
		const startDate: Date = isDate(offer.startDate) ? offer.startDate : new Date(offer.startDate);
		const tmpDate = `${startDate.getFullYear()}-${startDate.getMonth()}-${startDate.getDate()}`;

		return Number(offer.price) === dataPoint.price && tmpDate === dataPointDate;
	});

	dataPoint.offer = filteredOffer || null;

	return dataPoint;
}



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/models/day-price-matrix/convert-day-price-matrix.ts